<template>
  <div class="card">
    <div class="card-header">
      <div class="card-head-row card-tools-still-right">
        <h4 class="card-title">
          Playlists <span class="badge badge-primary ml-1">PRO</span>
        </h4>
      </div>
      <!-- <p class="card-category">
        Map of the distribution of users around the world
      </p> -->
    </div>
    <div class="card-body pos-relative p-0">
      <UpgradeOverlay v-if="!isPro" :title="$t('playlist_analytics')" :text="$t('playlist_analytics_text')"></UpgradeOverlay>
      <div class="p-5 text-center" v-if="loadingPlaylists">
        <i class="fas fa-spinner fa-2x fa-spin text-muted"></i>
      </div>
      <div v-if="!loadingPlaylists">
        <table class="card-list table mb-0">
          <thead>
            <tr>
              <th>Playlist</th>
              <th class="hide-mobile">{{ $t('followers') }}</th>
              <th>{{ $t('streams') }}</th>
              <th class="hide-mobile">{{ $t('platform') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in playlists" v-bind:key="`${index}_playlist`">
              <td class="item-list">
                <div class="avatar">
                  <img :src="item.data.image || defaultImage" :alt="item.data.title" class="avatar-img rounded-circle" onerror="this.src = '/static/img/img-placeholder.jpg'">
                </div>
                <div class="info-user ml-3">
                  <a target="_blank" :href="getPlaylistUrl(item)" class="playlist-name">{{ item.data.title }}</a>
                  <div class="status">{{ item.data.author }}</div>
                </div>
              </td>
              <td class="hide-mobile">
                {{ item.data.followers }}
              </td>
              <td>{{ getStreams(item.plays) }}</td>
              <td class="hide-mobile">
                {{ item.dspName }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="!loadingPlaylists && !playlists.length" class="mt-2 p-4">
        {{ $t('no_data_range') }}<br/><br/>
        <i class="fa fa-info-circle text-info mr-1"></i> <span v-html="$t('get_more_streams')"></span>
      </div>
      <div v-if="!isPro && !loadingPlaylists" class="p-4 mt-4 mb-4">-</div>
    </div>
  </div>
</template>
<script>
import Select2 from '../components/utils/Select2'
import Analytics from '../services/analytics'
import UpgradeOverlay from '../components/UpgradeOverlay'
import moment from 'moment'
import _ from 'underscore'

export default {
  name: 'PlaylistsCard',
  props: ['artists', 'artistId', 'fugaId'],
  data: function () {
    return {
      isPro: false,
      defaultImage: '/static/img/img-placeholder.jpg',
      spotifyLogo: '/static/img/spotify-logo-big.png',
      loadingPlaylists: false,
      playlistFilters: true,
      playlistFrom: '',
      playlistTo: '',
      playlists: []
    }
  },
  methods: {
    getPlaylistUrl: function (data) {
      if (data.dspName === 'Spotify') {
        return `https://open.spotify.com/playlist/${data.id.replace('spotify:playlist:', '')}`
      } else if (data.dspName === 'Deezer') {
        return `https://www.deezer.com/en/playlist/${data.id}`
      } else if (data.dspName === 'Apple Music') {
        return `https://music.apple.com/us/playlist/${data.id}`
      } else {
        return data.id
      }
    },
    getStreams: function (plays) {
      let total = 0

      _.each(plays, play => {
        total += play.plays
      })

      return total
    },
    getPlaylistsData: function () {
      this.loadingPlaylists = true

      Analytics.getPlaylists({
        artist_id: this.fugaId,
        from: this.playlistFrom,
        to: this.playlistTo
      }).then(response => {
        this.loadingPlaylists = false
        this.playlists = response.data.items

        _.each(this.playlists, (item) => {
          if (item.data.author === 'Spotify AI') {
            item.data.image = this.spotifyLogo
            item.data.followers = 'Everyone'
          }
        })
      })
    },
    initPickers: function () {
      // Countries
      this.playlistFrom = moment().subtract(30, 'days').format('YYYY-MM-DD')
      this.playlistPickerFrom = window.$('#playlist_from').datetimepicker({
        defaultDate: moment().subtract(30, 'days'),
        format: 'LL'
      })

      this.playlistPickerFrom.on('dp.change', item => {
        this.playlistFrom = item.date.format('YYYY-MM-DD')

        if (this.playlistPickerTo.data('DateTimePicker').viewDate().diff(item.date, 'days') > 0) {
          this.getPlaylistsData()
        }
      })

      this.playlistTo = moment().subtract(2, 'days').format('YYYY-MM-DD')
      this.playlistPickerTo = window.$('#playlist_to').datetimepicker({
        defaultDate: moment().subtract(2, 'days'),
        maxDate: moment().subtract(2, 'days'),
        format: 'LL'
      })

      this.playlistPickerTo.on('dp.change', item => {
        this.playlistTo = item.date.format('YYYY-MM-DD')

        if (item.date.diff(this.playlistPickerFrom.data('DateTimePicker').viewDate(), 'days') > 0) {
          this.getPlaylistsData()
        }
      })
    }
  },
  watch: {
    artistId: function (value) {
      if (value) {
        this.getPlaylistsData()
      }
    }
  },
  created: function () {
    this.user = this.$user
  },
  mounted: function () {
    if (this.user.subscription && this.user.subscription.plan_name !== 'indiefy_lite') {
      this.isPro = true
      this.initPickers()

      setTimeout(() => {
        this.getPlaylistsData()
      }, 3000)
    }
  },
  components: {
    UpgradeOverlay,
    Select2
  }
}
</script>
<style lang="scss" scoped>

@media screen and (max-width: 576px) {
  .playlist-name {
    display: inline-block;
    font-size: 10px;
    max-width: 100px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .item-list {
    padding: 0 !important;
  }

  .hide-mobile {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PlaylistsCard.vue